export const API_SOISALAK = "https://soi-salak.rotendaokab.go.id/api";
//"http://localhost:5000/api";

export const API_SOISALAK_UPLOAD = "https://soi-salak.rotendaokab.go.id";
//'https://SoiSalak.rotendaokab.go.id/api/';
//'http://localhost:4000/api/';

export const ADMINS_LOGIN = API_SOISALAK + "/users/admin/login";
export const ADMINS_LOGOUT = API_SOISALAK + "/users/admin/logout";
export const ADMINS_TOKEN = API_SOISALAK + "/admin/token";

export const USERS = API_SOISALAK + "/users/";
export const LOG_APP = API_SOISALAK + "logapp/";

export const API_TIMEOUT = 120000;
